export default function Footer() {
  return (
    <img
      src="/images/background.svg"
      alt="background"
      className="_pst-f _w-100vw _bt-0px _zid--1"
    />
  );
}
